/* CONCEPTS */
export const MONITOR_ORDER_COUNT_LOAD = "MONITOR_ORDER_COUNT_LOAD";
export const MONITOR_ORDER_COUNT_SUCCESS = "MONITOR_ORDER_COUNT_SUCCESS";
export const MONITOR_ORDER_COUNT_ERROR = "MONITOR_ORDER_COUNT_ERROR";
export const MONITOR_BILL_COUNT_LOAD = "MONITOR_BILL_COUNT_LOAD";
export const MONITOR_BILL_COUNT_SUCCESS = "MONITOR_BILL_COUNT_SUCCESS";

